module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ibox', [_c('template', {
    slot: "title"
  }, [_vm._v("企業登録")]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('company-form')], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3fa1294"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/company/Create.vue
// module id = 491
// module chunks = 1